// import {observer} from 'mobx-react'
import {withRouter} from 'react-router-dom'
// import UI from '../stores/UI'
// import CONTENT from '../stores/Content'

class Wrapper extends React.Component {

  constructor(props) {
    super(props)
  }

  componentDidUpdate(prevProps) {
    const hasChanged = this.props.location !== prevProps.location;
  }

  render() {
    return (
      <div className="fs">
        {this.props.children}
      </div>
    )
  }
}

export default withRouter(Wrapper)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/Wrapper.js